<!--
  ~ Copyright (c) Worldline 2023.
  -->

<app-structure>
    <router-outlet></router-outlet>
</app-structure>